import { Box, Card, Grid, Stack, Tab, TabContext, Typography, getSpacing } from "@compass/core";
import Tabs from "@mui/material/Tabs";
import {
  AprEtsResponse,
  AprRequestFilter,
  AprResponseActivitiesAndServices,
  AprSssResponse as AprResponseModel,
  AprSection,
  AprSectionId,
  AprSectionItemId,
} from "generated/openApi";

import "moment-timezone";
import { useState } from "react";
import { AprEtsTabA } from "./Tabs/AprEtsTabA";
import { AprEtsTabB } from "./Tabs/AprEtsTabB";
import { AprEtsTabC } from "./Tabs/AprEtsTabC";
import { AprEtsTabD } from "./Tabs/AprEtsTabD";
import { AprEtsTabE } from "./Tabs/AprEtsTabE";
import { AprEtsTabF } from "./Tabs/AprEtsTabF";
import { AprEtsTabG } from "./Tabs/AprEtsTabG";
import { AprEtsTabH } from "./Tabs/AprEtsTabH";
import { AprEtsTabM } from "./Tabs/AprEtsTabM";
import { AprEtsTabK } from "./Tabs/AprEtsTabK";
import { AprEtsTabI } from "./Tabs/AprEtsTabI";
import { AprEtsTabJ } from "./Tabs/AprEtsTabJ";
import { AprEtsTabL } from "./Tabs/AprEtsTabL";
import { AprEtsTabIIIA } from "./Tabs/AprEtsTabIIIA";
import { AprEtsTabIVA } from "./Tabs/AprEtsTabIVA";
import { AprEtsTabIVB } from "./Tabs/AprEtsTabIVB";
import { AprEtsTabIVC } from "./Tabs/AprEtsTabIVC";
import { AprEtsTabIVD } from "./Tabs/AprEtsTabIVD";
import { AprEtsTabIVE } from "./Tabs/AprEtsTabIVE";
import { AprEtsTabIVE2 } from "./Tabs/AprEtsTabIVE2";

export type AprEtsTab = "A" | "B" | "C" | "D" | "E" | "F" | "G" | "H" | "I" | "J" | "K" | "L" | "M" | "Section II" | "Section III" | "III-A" | "Section IV" | "IV-A" | "IV-B" | "IV-C" | "IV-D" | "IV-E" | "IV-E2";

export const AprEtsBody = (props: {
  filter: AprRequestFilter;
  response: AprEtsResponse;
  aprSections: AprSection[];
  selectedSectionItemIds: number[];
}) => {
  const [currentTab, setCurrentTab] = useState<AprEtsTab>("A");
  const availableTabs: AprEtsTab[] = ["Section II", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "Section III", "III-A", "Section IV", "IV-A", "IV-B", "IV-C", "IV-D", "IV-E", "IV-E2"];

  const getLabel = (tab: AprEtsTab): string => {
    if (tab == "III-A") return "A";
    if (tab == "IV-A") return "A";
    if (tab == "IV-B") return "B";
    if (tab == "IV-C") return "C";
    if (tab == "IV-D") return "D";
    if (tab == "IV-E") return "E";
    if (tab == "IV-E2") return "E2";
    return tab;
  }

  return (
    <Card style={{ height: "100%"}}>
      <Grid container spacing="sm" style={{ height: "100%"}}>
        <Grid item xs={1}>
          <TabContext value={currentTab || "A"}>
            <Tabs
              orientation="vertical"
              onChange={(e, value) => setCurrentTab(value)}
              value={currentTab}
              variant="standard"
              scrollButtons
              allowScrollButtonsMobile
            >
              {availableTabs?.map((tab) => 
                (tab == "Section II" || tab == "Section III" || tab == "Section IV") ? <Box key={tab} sx={{ my: 1, px: 2 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  {tab}
                </Typography>
              </Box>
              :
                <Tab key={tab} label={getLabel(tab)} value={tab} />
              )}
            </Tabs>
          </TabContext>
        </Grid>
        <Grid item xs={11}>
          {currentTab == "A" && <AprEtsTabA data={props.response.tabA} properties={props.response.properties} />}
          {currentTab == "B" && <AprEtsTabB data={props.response.tabB} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "C" && <AprEtsTabC data={props.response.tabC} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "D" && <AprEtsTabD data={props.response.tabD} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "E" && <AprEtsTabE data={props.response.tabE} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "F" && <AprEtsTabF properties={props.response.properties} />}
          {currentTab == "G" && <AprEtsTabG properties={props.response.properties} />}
          {currentTab == "H" && <AprEtsTabH data={props.response.tabH} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "I" && <AprEtsTabI data={props.response.tabI} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "J" && <AprEtsTabJ data={props.response.tabJ} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "K" && <AprEtsTabK data={props.response.tabK} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "L" && <AprEtsTabL data={props.response.tabL} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "M" && <AprEtsTabM data={props.response.tabM} properties={props.response.properties} />}
          {currentTab == "III-A" && <AprEtsTabIIIA data={props.response.tab3A} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "IV-A" && <AprEtsTabIVA data={props.response.tab4A} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "IV-B" && <AprEtsTabIVB data={props.response.tab4B} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "IV-C" && <AprEtsTabIVC data={props.response.tab4C} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "IV-D" && <AprEtsTabIVD data={props.response.tab4D} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "IV-E" && <AprEtsTabIVE data={props.response.tab4E} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
          {currentTab == "IV-E2" && <AprEtsTabIVE2 data={props.response.tab4E2} totalTabA={props.response.tabA?.totalParticipants} properties={props.response.properties} />}
        </Grid>
      </Grid>
    </Card>
  );
};

